<template>
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3219_6451)">
      <path
        d="M5.50341 8.71882L5.49991 0.999816C5.49991 0.867208 5.55258 0.740031 5.64635 0.646263C5.74012 0.552495 5.8673 0.499816 5.99991 0.499816C6.13251 0.499816 6.25969 0.552495 6.35346 0.646263C6.44723 0.740031 6.49991 0.867208 6.49991 0.999816L6.50341 8.71032L7.95941 7.25382C8.05317 7.16008 8.18032 7.10742 8.3129 7.10742C8.44549 7.10742 8.57264 7.16008 8.66641 7.25382C8.76014 7.34758 8.8128 7.47473 8.8128 7.60732C8.8128 7.7399 8.76014 7.86705 8.66641 7.96082L7.06091 9.56832C6.9216 9.70771 6.7562 9.81828 6.57415 9.89372C6.3921 9.96917 6.19697 10.008 5.99991 10.008C5.80284 10.008 5.60771 9.96917 5.42566 9.89372C5.24361 9.81828 5.07821 9.70771 4.93891 9.56832L3.3334 7.96232C3.23967 7.86855 3.18701 7.7414 3.18701 7.60882C3.18701 7.47623 3.23967 7.34908 3.3334 7.25532C3.42717 7.16158 3.55432 7.10892 3.6869 7.10892C3.81949 7.10892 3.94664 7.16158 4.04041 7.25532L5.50341 8.71882Z"
        fill="#434343"
      />
      <path
        d="M11 9V11C11 11.1326 10.9473 11.2598 10.8536 11.3536C10.7598 11.4473 10.6326 11.5 10.5 11.5H1.5C1.36739 11.5 1.24021 11.4473 1.14645 11.3536C1.05268 11.2598 1 11.1326 1 11V9C1 8.86739 0.947322 8.74021 0.853553 8.64645C0.759785 8.55268 0.632608 8.5 0.5 8.5C0.367392 8.5 0.240215 8.55268 0.146447 8.64645C0.0526784 8.74021 0 8.86739 0 9L0 11C0 11.3978 0.158035 11.7794 0.43934 12.0607C0.720644 12.342 1.10218 12.5 1.5 12.5H10.5C10.8978 12.5 11.2794 12.342 11.5607 12.0607C11.842 11.7794 12 11.3978 12 11V9C12 8.86739 11.9473 8.74021 11.8536 8.64645C11.7598 8.55268 11.6326 8.5 11.5 8.5C11.3674 8.5 11.2402 8.55268 11.1464 8.64645C11.0527 8.74021 11 8.86739 11 9Z"
        fill="#434343"
      />
    </g>
    <defs>
      <clipPath id="clip0_3219_6451">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
